'use client';

import { isValidPhoneNumber } from 'libphonenumber-js';
import PhoneInput from '../../../atoms/PhoneInput/PhoneInput';
import { getValidationResponse } from '../utils';
import type { PhoneField } from '../types';
import type { CountryCode as LibPhoneCountryCode } from 'libphonenumber-js';
import type { UseFormRegister, FieldValues, FieldErrors } from 'react-hook-form';

export type PhoneControlProps = {
  field: PhoneField;
  theme: 'dark' | 'light';
  direction: 'ltr' | 'rtl';
  register: UseFormRegister<FieldValues>;
  errors: FieldErrors<FieldValues>;
};

/**
 * Form control for phone input fields with validation
 * @component
 * @param {PhoneControlProps} props - Component props
 * @returns {JSX.Element} Phone control component
 */
const PhoneControl = ({ field, theme, direction, register, errors }: PhoneControlProps) => {
  return (
    <PhoneInput
      theme={theme}
      key={`form_field_${field.name}`}
      label={field.label}
      name={field.name}
      required={field.required}
      value={field.value}
      register={() =>
        register(field.name, {
          required: field.required ? field.validationMessages.required : false,
          validate: (value: string) => {
            if (!value) return true;
            try {
              const countryCode = (field?.selectedOption || 'US') as LibPhoneCountryCode;
              const isValid = isValidPhoneNumber(value, countryCode);
              return isValid || field.validationMessages.pattern || 'Invalid phone number';
            } catch {
              return field.validationMessages.pattern || 'Invalid phone number';
            }
          },
        })
      }
      validationResponse={getValidationResponse({ field: field.name, errors })}
      direction={direction}
      selectedOption={field?.selectedOption}
    />
  );
};

export default PhoneControl;
